require('./bootstrap');
require('slick-carousel');
require('select2');

/* Ajax load end trigger loading screen and close alert message after 5 second */
$body = $("body");
$(document).on({
    ajaxStart: function() { $body.addClass("loading");    },
    ajaxStop: function() { 
        setTimeout(function() {
        $body.removeClass("loading"); 
        }, 500);
        setTimeout(function(){
            $("div.alert").animate({
                    opacity: 0, // animate slideUp
                    marginRight: '-200px'
                }, 
                'slow', 'linear', function() {
                    $(this).remove();
            });
        }, 5000 );
    }     
});

$(function (e) {
    /* close alert message after 5 second */
    setTimeout(function(){
        $("div.alert").animate({
                opacity: 0, // animate slideUp
                marginRight: '-200px'
            }, 
            'slow', 'linear', function() {
                $(this).remove();
        });
    }, 5000 );

    /* Disable search input enter event */
    $(window).keydown(function(event){
        if(event.keyCode == 13) {
            event.preventDefault();
            return false;
        }
    });

    $( document ).ready(function() {
        /* Show Cookies Modal on first time load users */
        let existCookie = $("#exist_cookie").val();
        let existSubcription = $("#exist_subcription").val();
        const cookies_modal_element = document.getElementById('cookies_modal');
        var cookies_modal = bootstrap.Modal.getOrCreateInstance(cookies_modal_element);

        if ( !existCookie ) {
            cookies_modal.show();
        }else{
            $(document).ready(function(e) {
                showModal('flash_sales_modal');
            });
        }
        
        // Submit Cookie
        $('#cookies_form').submit( function(e){
            e.preventDefault();
            var formData = new FormData(this);
            var action_url = $(this).attr('data-action');
            $.ajax({
                type: 'POST',
                cache: false,
                contentType: false,
                processData: false,
                url: action_url,
                data: formData,
                success: function(data){
                    $("#exist_cookie").val(data.data)
                    cookies_modal.hide();
                    if (!existCookie) {
                        showModal('flash_sales_modal');
                    }
                }
            });
        });

        cookies_modal_element.addEventListener('hide.bs.modal', function (event) {
            if (document.activeElement && cookies_modal_element.contains(document.activeElement)) {
                document.activeElement.blur();
            }

            if ( !existSubcription ) {
                showModal('subscription_modal');
            }
        });

        // subscription form
        $('#switch_lang_button').click(function(){
            var lang = $(this).data('lang');
            var next_lang = lang == 'en' ? 'th' : 'en';
            $(this).data('lang', next_lang);
            $(this).html(next_lang.toUpperCase());

            var csrf_token = $('meta[name="csrf-token"]').attr('content'); // Get csrf token
            $.post('/locale-ajax/' + lang, {'_token': csrf_token}, function(result) {
                console.log(result);
                $.each(result.response, function(k, v){
                    $(`#${k}`).html(v);
                });
            }, "json");
        });

        $('#close_subcription').submit(function(e){
            e.preventDefault();
            var formData = new FormData(this);
            var action_url = $(this).attr('data-action');
            $.ajax({
                type: 'POST',
                cache: false,
                contentType: false,
                processData: false,
                url: action_url,
                data: formData,
                success: function(data){
                    $("#exist_subcription").val(data.data)
                    hideModal('subscription_modal');
                }
            });
        });

        $('#profile_form input, #profile_form select').on('change', function(e){
            var birthday = ['day', 'month', 'year'];
            if( birthday.includes($(this).attr('id')) ) {
                let birthday_valid = true;
                $.each(birthday, function(k, v){
                    if ( !$(`#${v}`).val() ){
                       birthday_valid = false; 
                    }
                });
                if( birthday_valid ) $('#invalid_birthday').hide();
            }else{
                $('#invalid_'+$(this).attr('id')).hide();
            }
        });

        /* Submit modal form */
        $("#profile_form").submit(function(e){
            e.preventDefault();
            var formData = new FormData(this);
            var action_url = $(this).attr('data-action');
            $.ajax({
                type: 'POST',
                cache: false,
                contentType: false,
                processData: false,
                url: action_url,
                data: formData,
                success: function(data){
                    $('#close_subcription').submit();
                },
                error: function (xhr, ajaxOptions, thrownError){
                    $.each(xhr.responseJSON, function(k, v){
                        var birthday = ['day', 'month', 'year'];
                        if( birthday.includes(k) ) $('#invalid_birthday').show();
                        $('#invalid_'+k).show();
                    });
                }
            });
        });
    });
    
    /* order type navbar */
    $(document).click(function (event) {
        var clickover = $(event.target);
        var _opened = $(".navbar-collapse").hasClass("collapse show");
        if (_opened === true && !clickover.hasClass("navbar-toggle")) {
            $("button.navbar-toggler").click();
        }
    });

    /* order type select on click */
    $('body').on('click', '.home-select-tab', function(e){
        var get_current_tab = $(this).data('method');
        if( !( $(this).hasClass('active') ) ){
            $('.home-select-tab.active').removeClass('active');
            $('.home-select-input-location.active').removeClass('active');
            $(this).addClass('active');
            $('#'+get_current_tab).addClass('active');
        }
    });

    /* Language Change */
    // $('body').on('click', '#change_locale_btn', function(e){
        // $('#preloader').fadeIn(1000);
        /*var csrf_token = $('meta[name="csrf-token"]').attr('content'); // Get csrf token
        var lang = $(this).data('locate');
        $.post('/locale/' + lang, {'_token': csrf_token}, function(result) {
            window.location.reload();
        }, "json")
        .fail(function(jqXHR, textStatus, errorThrown) {
            $("#main_content").append('<div class="alert alert-danger">' + jqXHR.responseJSON.meta.message + '</div>');
        });*/
    // });
});